(function () {

  'use strict';



  const quiz    = document.getElementById('hq-quiz');

  const content = document.getElementById('hq-content');

  if (!quiz || !content) return;



  const STEP3_IMAGE_MAP = {

    'akne': 'akne',

    'rosacea': 'roascea',

    'neurodermitis': 'neurodermitis',

    'allgemeine unreinheiten': 'hormonelle'

  };



  const STEP3_PATH_MAP = {

    'rosacea': {

      pathNum: 1,

      url: 'https://hautliebe.de/pages/garantie?view=quiz-landing-roascea&pb=0&preview_theme_id=173835845900'

    },

    'neurodermitis': {

      pathNum: 2,

      url: 'https://hautliebe.de/pages/garantie?view=quiz-landing-neurodermitis&pb=0&preview_theme_id=173835845900'

    },

    'akne': {

      url: 'https://hautliebe.de/pages/garantie?view=quiz-landing-akne&pb=0&preview_theme_id=173835845900'

    },

    'allgemeine unreinheiten': {

      url: 'https://hautliebe.de/pages/garantie?view=quiz-landing-unreinheiten&pb=0&preview_theme_id=173835845900'

    }

  };



  const DEFAULT_GAUGE_IMAGE_KEY = 'neurodermitis';



  let currentStep = 0;



  let resultStep3 = '';

  let resultStep7 = '';

  let selectedPathNum = 0;

  let targetPageLink = '';

  let step3SelectionOrder = [];



  function normalizeStep3Label (val) {

    return (val || '').trim().toLowerCase();

  }



  function getStep3ImageKey () {

    for (let i = 0; i < step3SelectionOrder.length; i++) {

      const imageKey = STEP3_IMAGE_MAP[normalizeStep3Label(step3SelectionOrder[i])];

      if (imageKey) return imageKey;

    }

    return DEFAULT_GAUGE_IMAGE_KEY;

  }



  function applyStep3PathFromOrder () {

    for (let i = 0; i < step3SelectionOrder.length; i++) {

      const path = STEP3_PATH_MAP[normalizeStep3Label(step3SelectionOrder[i])];

      if (!path) continue;



      if (path.pathNum != null) selectedPathNum = path.pathNum;

      if (path.url) targetPageLink = path.url;

      return;

    }

  }



  function applySummaryGaugeImage (stepEl) {

    const imageKey = getStep3ImageKey();

    const images = stepEl.querySelectorAll('.hq-gauge-image');



    images.forEach((img) => img.classList.remove('is-active'));



    const active = stepEl.querySelector('.hq-gauge-image[data-gauge-key="' + imageKey + '"]');

    if (active) {

      active.classList.add('is-active');

      return;

    }



    if (images.length) images[0].classList.add('is-active');

  }



  function syncStep3SelectionOrder (optionEl) {

    const val = optionEl.dataset.value;

    if (!val) return;



    const norm = normalizeStep3Label(val);

    const idx = step3SelectionOrder.findIndex((item) => normalizeStep3Label(item) === norm);



    if (optionEl.classList.contains('is-selected')) {

      if (idx === -1) step3SelectionOrder.push(val);

    } else if (idx !== -1) {

      step3SelectionOrder.splice(idx, 1);

    }

  }



  function rebuildResultStep3 (inputEl) {

    resultStep3 = step3SelectionOrder.join('|');

    if (inputEl && inputEl.value.trim().length > 0) {

      resultStep3 += (resultStep3 ? '|' : '') + inputEl.value.trim();

    }

  }



  /* ── Navigation ─────────────────────────────────────────────── */



  function getStepEl (n) {

    return quiz.querySelectorAll('.hq-step[data-step="' + n + '"]');

  }



  function showStep (n) {

    const total = quiz.querySelectorAll('.hq-step').length;

    if (n < 0 || n >= total) return;



    getStepEl(currentStep).forEach((ele) => {

      ele.classList.remove('is-active');

      currentStep = n;

    });



    getStepEl(n).forEach((ele, index) => {

      if (!ele.dataset.path) {

        ele.classList.add('is-active');

        content.scrollTo({ top: 0, behavior: 'smooth' });

        triggerStepAnimations(ele);

      } else if (index == selectedPathNum) {

        ele.classList.add('is-active');

        content.scrollTo({ top: 0, behavior: 'smooth' });

        triggerStepAnimations(ele);

      }

    });



    if (currentStep == 12) {

      getStepEl(currentStep).forEach((ele) => {

        if (!resultStep3) return;

        const middleStr = resultStep3.replaceAll('|', ', ');

        const middleTextEle = ele.querySelector('.hq-info-middle-text');

        if (middleTextEle) middleTextEle.innerHTML = middleStr;

      });

    } else if (currentStep == 13) {

      getStepEl(currentStep).forEach((ele) => {

        if (!ele.classList.contains('is-active')) return;



        applySummaryGaugeImage(ele);



        const infoFromStep3 = ele.querySelector('.hq-info-summary-text-from-step3');

        if (infoFromStep3 && resultStep3) {

          infoFromStep3.innerHTML = resultStep3.replaceAll('|', ', ');

        }



        const result3container = ele.querySelector('[js-result-step3]');

        if (!result3container) return;



        result3container.innerHTML = '';

        if (resultStep3) {

          resultStep3.split('|').forEach((val) => {

            result3container.insertAdjacentHTML('afterbegin',

              '<div class="hq-result-value">' + val + '</div>'

            );

          });

        }

      });

    } else if (currentStep == 15) {

      setTimeout(() => {

        const openPopupBtn = document.querySelector('.gbpo-popup-button');

        if (openPopupBtn) {

          openPopupBtn.click();



          const popupBtn = document.querySelector('.qpo-button');

          if (popupBtn) {

            popupBtn.addEventListener('click', () => {

              goNext();



              const escEvent = new KeyboardEvent('keydown', {

                key: 'Escape',

                code: 'Escape',

                keyCode: 27,

                which: 27,

                bubbles: true,

                cancelable: true

              });

              document.dispatchEvent(escEvent);

            });

          }

        }

      }, 1000);

    } else if (currentStep == 16) {

      getStepEl(currentStep).forEach((ele) => {

        if (ele.classList.contains('is-active')) {

          const ctaBtn = ele.querySelector('.hq-cta');

          if (ctaBtn) {

            ctaBtn.setAttribute('href', targetPageLink);

            ctaBtn.removeAttribute('[data-action]');

          }

        }

      });

    }

  }



  function goNext () {

    showStep(currentStep + 1);

  }



  /* ── Step animations (driven by data-step-type) ─────────────── */



  function triggerStepAnimations (stepEl) {

    const type = stepEl.dataset.stepType;



    stepEl.querySelectorAll('.hq-bar-fill[data-animate]').forEach(function (bar, i) {

      bar.style.width = '0%';

      setTimeout(function () {

        bar.style.width = bar.dataset.animate + '%';

      }, 300 + i * 80);

    });



    if (type === 'timeline') {

      stepEl.querySelectorAll('.hq-bar-col__bar').forEach(function (bar, i) {

        bar.style.height = '0px';

        bar.style.transition = 'none';

        setTimeout(function () {

          bar.style.transition = 'height ' + (0.8 + i * 0.2) + 's ease ' + (i * 0.1) + 's';

          bar.style.height = bar.dataset.height + 'px';

        }, 300);

      });

    }



    if (type === 'summary') {

      applySummaryGaugeImage(stepEl);



      const thumb = stepEl.querySelector('.hq-gauge-thumb');

      const label = stepEl.querySelector('.hq-gauge-label');

      const track = stepEl.querySelector('.hq-gauge-track');

      const targetPct = track ? track.dataset.targetPct || '78' : '78';



      if (thumb) thumb.style.left = '0%';

      if (label) label.style.left = '0%';

      setTimeout(function () {

        if (thumb) thumb.style.left = targetPct + '%';

        if (label) label.style.left = targetPct + '%';

      }, 400);

    }



    if (type === 'analysis') {

      runAnalysis(stepEl);

    }

  }



  function runAnalysis (stepEl) {

    const rows = stepEl.querySelectorAll('.hq-analysis-row');

    const cta  = stepEl.querySelector('[data-action="next"]');



    rows.forEach(function (row, i) {

      row.classList.remove('is-done');

      row.style.opacity = i === 0 ? '1' : '0.3';

      const fill = row.querySelector('.hq-bar-fill');

      if (fill) fill.style.width = '0%';

    });

    if (cta) cta.classList.add('is-disabled');



    rows.forEach(function (row, i) {

      setTimeout(function () {

        row.style.opacity = '1';

        row.classList.add('is-done');

        const fill = row.querySelector('.hq-bar-fill');

        if (fill) fill.style.width = '100%';



        if (i === rows.length - 1 && cta) {

          setTimeout(function () { cta.classList.remove('is-disabled'); }, 1000);

        }



        if (i === rows.length - 1) {

          getStepEl(16).forEach((ele) => {

            const ctaButtonEle = ele.querySelector('.hq-cta');

            if (ctaButtonEle) ctaButtonEle.click();

          });

        }

      }, 800 + i * 1200);

    });

  }



  /* ── Multi-select CTA gate ───────────────────────────────────── */



  function updateMultiCta (stepEl) {

    const selected = stepEl.querySelectorAll('.hqmq-option.is-selected');

    const inputEl  = stepEl.querySelector('.hqmq-input');

    const cta      = stepEl.querySelector('[data-action="next-multi"]');

    const hasVal   = selected.length > 0 || (inputEl && inputEl.value.trim().length > 0);



    if (cta) cta.classList.toggle('is-disabled', !hasVal);



    if (!hasVal) {

      if (stepEl.dataset.step == 3) step3SelectionOrder = [];

      return;

    }



    if (stepEl.dataset.step == 3) {

      rebuildResultStep3(inputEl);

      applyStep3PathFromOrder();

    } else if (stepEl.dataset.step == 7) {

      resultStep7 = '';

      for (let i = 0; i < selected.length; i++) {

        const val = selected[i].dataset.value;

        if (i != 0) resultStep7 += '|';

        resultStep7 += val;

      }

      if (inputEl && inputEl.value.trim().length > 0) {

        resultStep7 += `|${inputEl.value.trim()}`;

      }

      localStorage.setItem('quiz_step7_result', resultStep7);

    }

  }



  /* ── Event delegation ────────────────────────────────────────── */



  quiz.addEventListener('click', function (e) {

    const btn = e.target.closest('[data-action]');

    if (!btn) return;



    const action = btn.dataset.action;

    const stepEl = btn.closest('.hq-step');



    switch (action) {

      case 'next':

        if (!btn.classList.contains('is-disabled')) goNext();

        break;



      case 'single':

        btn.classList.add('is-selected');

        setTimeout(() => { goNext(); }, 500);

        break;



      case 'multi':

        btn.classList.toggle('is-selected');

        if (stepEl && stepEl.dataset.step == 3) syncStep3SelectionOrder(btn);

        if (stepEl) updateMultiCta(stepEl);

        break;



      case 'next-multi':

        if (!btn.classList.contains('is-disabled')) goNext();

        break;

    }

  });



  quiz.addEventListener('input', function (e) {

    if (!e.target.classList.contains('hqmq-input')) return;

    const stepEl = e.target.closest('.hq-step');

    if (stepEl) updateMultiCta(stepEl);

  });



})();


